import { render, staticRenderFns } from "./PredictionTable.vue?vue&type=template&id=61ecf02a&scoped=true"
import script from "./PredictionTable.vue?vue&type=script&lang=js"
export * from "./PredictionTable.vue?vue&type=script&lang=js"
import style0 from "./PredictionTable.vue?vue&type=style&index=0&id=61ecf02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ecf02a",
  null
  
)

export default component.exports